import { Component, Input, OnInit } from '@angular/core';
import { NewAssetWizardService } from 'src/app/services/new-asset-wizard.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';

@Component({
  selector: 'app-new-asset-card',
  templateUrl: './new-asset-card.component.html',
  styleUrls: ['./new-asset-card.component.scss'],
})
export class NewAssetCardComponent implements OnInit {

  @Input('name') name: string;
  @Input('displayName') displayName: string;
  @Input('color') color: string;
  @Input('icon') icon: string;

  constructor(
    public assetWizardService: NewAssetWizardService,
    private unfocusService: UnfocusElementService
  ) { }

  ngOnInit() { }

  getBorderTop(color: string): string {
    return "3px solid " + color;
  }

  getBorder(color: string, name: string): string {
    return this.assetWizardService.selectedAsset != name ? "0" : "3px solid " + color;
  }

  setSelected(event, name) {
    this.unfocusService.unfocus(event);
    this.assetWizardService.selectedAsset = name;
  }

}
